// extracted by mini-css-extract-plugin
export default {"container":"Flex_container__MH8R-"};